module.exports = {
  env: 'production',
  domain: ['hz.tsepcn.com'],
  aegisId: 'akNqIsanjBcOOiYfZS',
  reportDomain: 'd.baike.qq.com',
  cosAppId: '1304685099',
  bucket: 'tsep-prod-1304685099',
  region: 'ap-guangzhou',
};
